<template>
  <c-container form v-if="optins">
    <c-optin-group
      :optins="optins"
      @submit="onSubmit"
    >
      <!-- Title -->
      <template #title>情報配信サービスを変更</template>

      <!-- Contents -->
      <template>
        <p>
          会員の方に、最新のおすすめ情報をメールでご案内しています。<br>
          おすすめ情報メールは、ご登録いただいているメールアドレスに配信します。
        </p>
        <p>
          配信の登録・解除、および登録メールアドレスの変更をされた場合、設定が反映されるまで数日かかることがあります。<br>
          あらかじめご了承ください。
        </p>
      </template>

      <!-- Submit button text -->
      <template #submit-text>更新</template>
    </c-optin-group>
  </c-container>
</template>

<script>
import page from '@/mixins/page'
import COptinGroup from './COptinGroup'

import * as api from '@/api'
import { run } from '@/libs/a'

export default {
  name: 'Optins',
  mixins: [
    page('情報配信サービス')
  ],
  components: {
    COptinGroup
  },

  /**
   * データ取得
   */
  async prepare (to, from, store) {
    // ログイン中のユーザID を取得する
    const userID = store.getters['user/id']
    if (!userID) {
      throw new Error('The user is not logged in.')
    }

    // 個人情報を取得する
    const resp = await api.getUserOptins(userID)

    return {
      userID: resp.data.id,
      optins: resp.data.optins
    }
  },

  props: {
    userID: Number,
    optins: Object
  },

  methods: {
    /**
     * フォームが入力された
     *
     * @param {Object} form 入力されたフォームデータ
     * @param {Function} failed エラー時に呼び出すコールバック関数
     */
    onSubmit (form, failed) {
      run(async () => {
        await api.putUserOptins(this.userID, {
          optins: form
        })

        // 前のページに戻る
        this.back()
      })
    }
  }
}
</script>
